
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import logoImage from "@/assets/logo.png";


interface AdminLayoutProps {
  children: React.ReactNode;
  title: string;
  backLink: string;
  backLabel: string;
}

const AdminLayout = ({ children, title, backLink, backLabel }: AdminLayoutProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-elfGreen text-white p-4 shadow-md">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <img
              src={logoImage}
              alt="Elf Letter Bot Logo"
              className="h-10 w-auto"
            />
            <h1 className="text-xl font-bold">{title}</h1>
          </div>
          <div>
            <Button 
              variant="outline" 
              className="bg-white text-elfGreen hover:bg-gray-100"
              onClick={() => navigate(backLink)}
            >
              <ArrowLeft size={16} className="mr-2" /> {backLabel}
            </Button>
          </div>
        </div>
      </header>

      <main className="container mx-auto p-4 md:p-8">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
